import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import DeleteButton from 'Components/ComponentLibrary/Components/Buttons/DeleteButton';

const styles = () => ({
  root: {},
});

const CancelMeetingButton = ({
  className,
  classes,
  onClick,
  disabled,
}) => {
  return (
    <DeleteButton
      className={classNames(classes.root, className)}
      onClick={onClick}
      title="Cancel Meeting"
      size="small"
      disabled={disabled}
    />
  );
};

CancelMeetingButton.defaultProps = {
  className: '',
};

CancelMeetingButton.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
};

export default withStyles(styles)(CancelMeetingButton);
